import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { filter, map, take } from 'rxjs';

export const superAdminGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  return authService.isLoading$.pipe(
    filter(loading => !loading),
    take(1),
    map(() => {
      if (!authService.isAuthenticated) {
        return false;
      }

      if (authService.isSuperAdmin) {
        return true;
      }

      router.navigate(['/']);
      return false;
    })
  );
};
